var TimelineModule = /** @class */ (function () {
    function TimelineModule() {
    }
    return TimelineModule;
}());
export { TimelineModule };
